import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';
import { useToaster } from '@iress-oss/ids-components';
import { ToasterDefaultStatusHeading } from '@xplan-pension-switching/common';

export const QueryClientLoader: FC<PropsWithChildren> = ({ children }) => {
    const toaster = useToaster();
    const queryClient = new QueryClient({
        defaultOptions: { queries: { staleTime: 1000 * 60 * 30, gcTime: 1000 * 60 * 30 } },
        queryCache: new QueryCache({
            onError: (error): void => {
                toaster.error({
                    heading: ToasterDefaultStatusHeading.Error,
                    children: (error as Error).message,
                    timeout: 0,
                });
            },
            onSuccess: (data): unknown => data,
        }),
        mutationCache: new MutationCache({
            onMutate: (_variables, _mutation): void => {
                console.log('Mutation started');
            },
            onError: (error, _variables, _context, _mutation): void => {
                toaster.error({
                    heading: ToasterDefaultStatusHeading.Error,
                    children: (error as Error).message,
                    timeout: 0,
                });
            },
            onSuccess: (data, _variables, _context, _mutation): unknown => {
                toaster.success({
                    heading: ToasterDefaultStatusHeading.Success,
                    children: 'Operation successful',
                    timeout: 0,
                });
                return data;
            },
        }),
    });

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
